import FacetWrapper from './FacetWrapper/FacetWrapper';
import { getFilterPreparation, hashCode } from './utils';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { FacetFilter } from 'festo-react-ui-kit';
import { econdaClickEvent } from '../../Econda';
import { updateFilters } from '../../features/filter/slice';
import { FilterBase } from '../../features/filter/interfaces';
import { FilterValueKey } from '../../features/filter/utils';
import useTranslation from '../../features/translation/hooks/useTranslation';
import ResultsDisplay from './ResultsDisplay/ResultsDisplay';
import ChipsContainer from '../ChipsContainer';
import '../Filters/FacetWrapper.scss';

enum TranslationKeys {
  FILTERS_TITLE = 'resultsFilter',
  SHOW_RESULTS = 'showResults',
}

export default function ResultsFilter(): JSX.Element {
  const t = useTranslation();
  const filters = useAppSelector((state) => state.filter.filtersStructure);
  const filtersValue = useAppSelector((state) => state.filter.filtersValue);
  const dispatch = useAppDispatch();

  const handleFilterChange = (
    filterName: string,
    newValue: string | number,
    id: number,
    childFilterId?: number,
  ): void => {
    econdaClickEvent('application parameters', 'results filter', `${filterName}`, `${newValue}`);

    if (
      filterName === FilterValueKey.SUPPLY_PRESSURE &&
      newValue <= filtersValue[FilterValueKey.OUTPUT_PRESSURE] &&
      filtersValue[FilterValueKey.CALCULATION_RESULT] === 'QN'
    ) {
      const updatedOutputPressureValue = +newValue;

      dispatch(
        updateFilters({
          key: FilterValueKey.OUTPUT_PRESSURE,
          newValue: updatedOutputPressureValue,
        }),
      );
    }
    dispatch(
      updateFilters({
        key: filterName,
        newValue,
      }),
    );
  };

  return (
    <div>
      <FacetFilter
        title={t(TranslationKeys.FILTERS_TITLE)}
        className="ems-facet-filter-appication-endpoint"
        buttonText={t(TranslationKeys.SHOW_RESULTS)}
      >
        {filters.map((filter, index) => {
          const updatedFilter = getFilterPreparation({ filter, filtersValue, t });
          return (
            <FacetWrapper
              filter={updatedFilter as FilterBase}
              key={hashCode(`${filter.id + index}`.toString())}
              root
              labelAsTitle
              visible
              onFilterChange={(filterName, newValue, _, childFilterId): void =>
                handleFilterChange(filterName, newValue, filter.sort, childFilterId)
              }
              id={filter.sort}
            />
          );
        })}
      </FacetFilter>

      <ChipsContainer />
      <ResultsDisplay isQN={filtersValue[FilterValueKey.CALCULATION_RESULT] === 'QN'} results={filtersValue} />
    </div>
  );
}
